import React from 'react';
import { Outlet } from "react-router";

const RelationshipLayout: React.FC = () => {
    return (
        <div className="relationship-container">
            <Outlet /> 
        </div>
    );
};

export default RelationshipLayout;